import React from 'react';
import { ThemeProps } from 'styled-components';
import { Column, Row } from '../../components/Grid';
import NavigationGroup from '../../components/layout/NavigationGroup';
import {
  Navigation,
  NavigationLink,
  NavigationList,
  NavigationListItem
} from '../../components/Navigation';
import { Paragraph } from '../../components/Paragraph';
import { Section, SectionProps } from '../../components/Section';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import Typo3Label from '../../provider/Typo3Provider/Typo3Label';
import { Theme } from '../../theme';
import { media } from '../../theme/base/mixins';
import { StyledComponent } from '../../types';

interface ServiceContainerProps {
  serviceEntries: MenuEntry[];
}

export const ServiceSection: StyledComponent<SectionProps> = Section.extend`
  border-top: 1px solid
    ${(props: ThemeProps<Theme>) => props.theme.colors.white};

  ${media.large`
    border-top: 0;
  `}

  ${Row} {
    margin: 10px 0;

    ${Column} {
      width: 100%;
    }

    ${Paragraph} {
      margin: 10px 0;
      text-align: center;
    }

    ${Navigation} {
      background: none;
      margin: 20px 0;
    }

    ${NavigationList} {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
    }

    ${NavigationListItem} {
      margin: 0 0 10px;
      width: 50%;

      &:nth-child(3n) {
        page-break-after: always;
        /* FIXME: empty value!!! chose 'always' */
        break-after: always;
      }
    }

    ${NavigationLink} {
      line-height: ${(props: ThemeProps<Theme>) =>
        props.theme.defaults.fontSize};
    }

    ${media.large`
      flex-direction: row;

      ${Column} {
        width: auto;
      }

      ${Navigation} {
        margin: 0;
      }

      ${NavigationList} {
        text-align: left;
        display: block;
      }

      ${NavigationListItem} {
        margin: 14px 0 14px 20px;
        display: inline-block;
        width: auto;

        :not(:first-child) {
          padding-left: 20px;
          border-left: 1px solid ${(props: ThemeProps<Theme>) =>
            props.theme.colors.white};
          line-height: ${(props: ThemeProps<Theme>) =>
            props.theme.defaults.fontSize};
        }
      }

      ${NavigationList} {
        text-align: left;
      }

      ${NavigationListItem} {
        margin: 4px 20px 4px 0;
        display: inline-block;

        :not(:first-child) {
          padding-left: 20px;
          border-left: 1px solid ${(props: ThemeProps<Theme>) =>
            props.theme.colors.white};
          line-height: ${(props: ThemeProps<Theme>) =>
            props.theme.defaults.fontSize};
        }
      }

      ${Paragraph} {
        margin: 0;
        text-align: left;
      }
    `};
  }
`;

const ServiceContainer = ({ serviceEntries }: ServiceContainerProps) => (
  <Row noGap bg="black">
    <Column>
      <ServiceSection>
        <Row>
          <Navigation>
            <NavigationList>
              <NavigationGroup entries={serviceEntries} />
            </NavigationList>
          </Navigation>
        </Row>
        <Row>
          <Paragraph service>
            © {new Date().getFullYear()}{' '}
            <Typo3Label label="footer.copyright" />
          </Paragraph>
        </Row>
      </ServiceSection>
    </Column>
  </Row>
);

export default ServiceContainer;
